import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import $ from "jquery";
import { Client_Search, Dashboard_Client_Report, pledgeBaseUrl } from "../../Configuration/API_URL";
import { Constants } from "../../CommonMethhods/Constants";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import {
  AESEncryption,
  ApiResDecrypt,
  OpenWindowWithPost,
} from "../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { useDebounce } from "../../Components/useDebounce";
import SmallLoader from "../../Components/Common/smallLoader";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function PledgeReportSidebar() {
  const storeToken = localStorage.getItem("ssoToken");
  const [clientName, setClientName] = useState("");
  const [clientList, setClientList] = useState([]);
  const [clientCode, setClientCode] = useState("");
  const [scrollLoader, setScrollLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);
    const [nameError, setNameError] = useState("");
  const [count, setCount] = useState();

  const debouncedValue = useDebounce(clientName, 1000);
  
    useEffect(() => {
      handleClientName(debouncedValue)
    }, [debouncedValue]);

  async function searchApiDetail(code, NoPage) {
    // $(".write-search.pledgeReport").addClass("show-result scroll-table");
    let payloadValue = {
      keyword: code,
      Status: "",
      PageNo: NoPage,
      PageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axiosInstance.post(
        Client_Search.Search_URL,

        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(getSearchDetail?.data);
      if (res?.status === 0) {
        setCount(res?.data?.TotalCount);
        setNameError(false);
        if (page > 1) {
          setClientList((prev) => {
            return [...prev, ...res?.data?.clients];
          });
        } else {
          setClientList(res?.data?.clients);
        }
      } else {
        setNameError(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setScrollLoader(false);
    }
  }
  const handleClientName = (data) => {
    if (data) {
      searchApiDetail(data, 1);
      setScrollLoader(true)
      setClientList([]);
      setPage(1);
    } 
  };

   useEffect(() => {
    if (page > 1) {
      searchApiDetail(clientName, page);
    }
  }, [page]);

  const handleScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };


  const getDpName = async () => {
    setLoader(true)
    let payloadValue = {
      clientCode: clientCode,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.Get_DP_Name,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if(res?.data?.dpName === "NSDL"){
          window.open(
          `${pledgeBaseUrl}/NSDL/DietRequest/Pledge?UserID=${clientCode}${"&source=cosmos"}`
        );
        } if(res?.data?.dpName === "CDSL"){
          window.open(
          `${pledgeBaseUrl}/DietRequest/Pledge?UserID=${clientCode}${"&source=cosmos"}`
        );
        }
      } else {
        toast.error(res?.message)
        
      }
    } catch (error) {
      console.log(error);
      
    } finally {
    setLoader(false)
    }
  };

  const handleOnClick = (e) => {
    setShow(false);
    if (clientName.length > 0) {
      if (clientCode) {
        getDpName()
        // window.open(
        //   `https://api.bajajfinservsecurities.in/api/dp/DietRequest/Pledge?UserID=${clientCode}${"&source=cosmos"}`
        // );
        return;
      } else {
        toast.error("Please Select Name/Code");
      }
    } else {
      toast.error("Please Enter Client Name/Code");
    }
  };
  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box">
          {/* <div>
            <h2 className="report-title">Pledge</h2>
          </div> */}

          <div className="row input-field-wrapper">
            <div className="col-md-4 col-sm-6">
              <div className="form-group">
                <label className="form-label">{Constants.Client_Name}</label>
                <div className="rm-custom-dropdown">
                  <input
                    id="input1"
                    type="text"
                    // className="input-text form-control"
                    className="input-st"
                    placeholder="Search by Name/ Code"
                    value={clientName}
                    // required
                    onChange={(e) => {
                      setClientName(e.target.value.toUpperCase());
                      setShow(true);
                    }}
                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                  }}
                  />
                  <button
                      className="rm-dropdown-btn"
                      onClick={() => setShow(!show)}
                    >
                      <span className="icon-right-arrow-triangle"></span>
                    </button>
                    {show && (
                  <>
                    <ul
                    className="rm-mapping-ap border-0"
                      // className="write-search pledgeReport border-0"
                      // id="pledgeReportid-scroll"
                      onScroll={(e) => handleScroll(e)}
                    >
                      {clientList && clientList.map((item, i) => (
                        <li
                        className="rm-maping-item-wrapper"
                          key={i}
                          onClick={() =>{
                            setClientCode(item?.clientCode)
                            setClientName(item?.clientname);
                            setShow(false);
                          }
                            // clientSet(item.clientname, item.clientCode, i)
                          }
                        >
                          <div> {item.clientname}</div>
                          <div>{item.clientCode}</div>
                        </li>
                      ))}
                      {scrollLoader && !loader && (
                        <div className="loader-center">
                          <LoaderForSearch />
                        </div>
                      )}
                      {nameError && !scrollLoader && (
                            <li
                              className="rm-maping-item-wrapper"
                              style={{
                                borderBottom: "none",
                                fontSize: "12px",
                              }}
                            >
                              {nameError}
                            </li>
                          )}
                    </ul>
                  </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
            >
              {loader ?
              <SmallLoader />
            :
              <>
              Pledge
              </>
            }
            </button>
          </div>
        </div>
      </main>
    </>
  );
}

export default PledgeReportSidebar;
